export default "__VITE_ASSET__CQdDMCL0__"